export default [
  { id: "TJAC", name: "TJAC - Tribunal de Justiça do Acre" },
  { id: "TJAL", name: "TJAL - Tribunal de Justiça de Alagoas" },
  { id: "TJAP", name: "TJAP - Tribunal de Justiça do Amapá" },
  { id: "TJAM", name: "TJAM - Tribunal de Justiça do Amazonas" },
  { id: "TJBA", name: "TJBA - Tribunal de Justiça da Bahia" },
  { id: "TJCE", name: "TJCE - Tribunal de Justiça do Ceará" },
  { id: "TJDFT", name: "TJDFT - Tribunal de Justiça do Distrito Federal e dos Territórios" },
  { id: "TJES", name: "TJES - Tribunal de Justiça do Espírito Santo" },
  { id: "TJGO", name: "TJGO - Tribunal de Justiça de Goiás" },
  { id: "TJMA", name: "TJMA - Tribunal de Justiça do Maranhão" },
  { id: "TJMT", name: "TJMT - Tribunal de Justiça de Mato Grosso" },
  { id: "TJMS", name: "TJMS - Tribunal de Justiça de Mato Grosso do Sul" },
  { id: "TJMG", name: "TJMG - Tribunal de Justiça de Minas Gerais" },
  { id: "TJPA", name: "TJPA - Tribunal de Justiça do Pará" },
  { id: "TJPB", name: "TJPB - Tribunal de Justiça da Paraíba" },
  { id: "TJPR", name: "TJPR - Tribunal de Justiça do Paraná" },
  { id: "TJPE", name: "TJPE - Tribunal de Justiça de Pernambuco" },
  { id: "TJPI", name: "TJPI - Tribunal de Justiça do Piauí" },
  { id: "TJRJ", name: "TJRJ - Tribunal de Justiça do Rio de Janeiro" },
  { id: "TJRN", name: "TJRN - Tribunal de Justiça do Rio Grande do Norte" },
  { id: "TJRS", name: "TJRS - Tribunal de Justiça do Rio Grande do Sul" },
  { id: "TJRO", name: "TJRO - Tribunal de Justiça de Rondônia" },
  { id: "TJRR", name: "TJRR - Tribunal de Justiça de Roraima" },
  { id: "TJSC", name: "TJSC - Tribunal de Justiça de Santa Catarina" },
  { id: "TJSP", name: "TJSP - Tribunal de Justiça de São Paulo" },
  { id: "TJSE", name: "TJSE - Tribunal de Justiça de Sergipe" },
  { id: "TJTO", name: "TJTO - Tribunal de Justiça do Tocantins" },
  { id: "TRF1", name: "TRF1 - Tribunal Regional Federal da 1ª Região" },
  { id: "TRF2", name: "TRF2 - Tribunal Regional Federal da 2ª Região" },
  { id: "TRF3", name: "TRF3 - Tribunal Regional Federal da 3ª Região" },
  { id: "TRF4", name: "TRF4 - Tribunal Regional Federal da 4ª Região" },
  { id: "TRF5", name: "TRF5 - Tribunal Regional Federal da 5ª Região" },
  { id: "TRF6", name: "TRF6 - Tribunal Regional Federal da 6ª Região" },
  { id: "STJ", name: "STJ - Superior Tribunal de Justiça" },
  { id: "STF", name: "STF - Supremo Tribunal Federal" },
];
